import { Link } from 'react-router-dom';
import { NextPrevAnnouncement } from 'types/Announcement';
import { announcementDetailUrl } from 'helper/helper';

import './NoticeNavigationArrow.scss';

interface Props {
    direction: string;
    announcement: NextPrevAnnouncement | null;
}

export const NoticeNavigationArrow = (props: Props) => {
    const { direction, announcement } = props;

    const url = announcementDetailUrl(
        announcement?.n_seq,
        announcement?.n_title
    );

    const renderArrow = (direction: string) => {
        if (direction === 'previous') {
            return (
                <svg
                    className='left-arrow'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 448 512'
                >
                    <path d='M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z'></path>
                </svg>
            );
        } else {
            return (
                <svg
                    className='right-arrow'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 448 512'
                >
                    <path d='M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z'></path>
                </svg>
            );
        }
    };

    return (
        <>
            <Link className='navigation-link' to={url}>
                <div className={`first_row ${direction}`}>
                    {direction === 'previous' ? renderArrow(direction) : null}
                    <div className='direction'>{direction}</div>
                    {direction === 'next' ? renderArrow(direction) : null}
                </div>
                <div className='announcement-title'>
                    {announcement?.n_title}
                </div>
            </Link>
        </>
    );
};
